import DocumentExpiryDateValidity from 'FeatureModules/Document/utils/documentCategory.utils';
import {
  EDocumentCategory,
  EDocumentVisibilityStatus,
  TDocumentCategory,
} from 'FeatureModules/Document/types/document.types';
import { IBasePartnerCompany } from 'FeatureModules/Partner/types/partner.types';
import * as Yup from 'yup';
import { createMediaSchema } from '../../../utils/sharedSchema.utils';

const document = {
  title: Yup.string()
    .default('')
    .test('test_title_empty', 'Please enter a document title', value => {
      // check if title is empty without extension name
      if (value && value.split('.').slice(0, -1).join('.').length === 0) {
        return false;
      }
      return true;
    }),
  ownedBy: Yup.object<IBasePartnerCompany>()
    .shape({
      id: Yup.string().required(),
      name: Yup.string().required(),
      logo: createMediaSchema('', false).nullable(),
      modifiedTimestamp: Yup.date().required(),
      createdTimestamp: Yup.date().required(),
      status: Yup.mixed().required(),
      externalId: Yup.string().optional().nullable(),
    })
    .default(undefined),
  linkedSites: Yup.array().default([]),
  comment: Yup.string().optional().default(undefined),
  category: Yup.mixed<EDocumentCategory>()
    .oneOf(Object.values(EDocumentCategory), 'Please select a valid document category')
    .required('Please select a document category'),
  certificateCatalogItemId: Yup.string()
    .nullable()
    .default(undefined)
    .when('category', {
      is: EDocumentCategory.CERTIFICATE,
      then: Yup.string().required('Please add a certificate'),
    }),
  issuedDate: Yup.date()
    .default(undefined)
    .when('category', {
      is: (category: TDocumentCategory) =>
        category && DocumentExpiryDateValidity[category]?.requireDate,
      then: Yup.date().required('Issued date is a required field'),
      otherwise: Yup.date().default(undefined),
    }),
  expiryDate: Yup.date()
    .optional()
    .default(undefined)
    .test('Check if date in past', 'Expiry date can not be in the past', value => {
      if (!value) return true;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return value >= today;
    })
    .min(Yup.ref('issuedDate'), 'Expiry date cannot be before issued date')
    .when('category', {
      is: (category: TDocumentCategory) =>
        category && DocumentExpiryDateValidity[category]?.requireDate,
      then: Yup.date().required('Issued date is a required field'),
      otherwise: Yup.date().optional(),
    }),
};

export const documentSchema = Yup.object().shape(document);

export const requestDocumentSchema = Yup.object().shape({
  ...document,
  visibility: Yup.mixed()
    .oneOf(Object.values(EDocumentVisibilityStatus), 'Please select a valid visibility setting')
    .default(EDocumentVisibilityStatus.PUBLIC)
    .required('Please select a visibility setting'),
});
